define((require) => {
    "use strict";

    var Action = require("shared/ui/experience/action/Action");

    /**
     * The <i>Editor action mixin</i> adds editor related functionality to Viewer Actions, such as ensuring that
     * for example Custom JS Actions will not try and execute the JS as that will never work when in the Editor, only
     * when embedded on the client site. <p>
     *
     * Note: this will only be applied to top level Experiences, not Experiences loaded embedded via a direct url
     * when shown in the Editor.
     *
     * @class ActionEditorMixin
     */
    return Action.mixin("ActionEditorMixin", {

        embedded: true, // since it has an id and we do not want to call the server on sync!

        activate: function() {
            if (this._clientSpace) {
                this._log(Action.NOT_EMBEDDED_MESSAGE);
                alert(Action.NOT_EMBEDDED_MESSAGE);
                return false;
            }
            return this.__super();
        },

        /**
         * Returns a JSON object that uniquely identifies this Action so it can be selected in the Editor
         * when editing.
         *
         * @return {type:String, actionId:String} Returns a json object with the Action "type" and optionally
         *         the prototypical "actionId"; never falsey.
         */
        getIdentifier: function() {
            var identifier = {
                type: this.get("type")
            };

            // A company might have more than one owned action of a specific type. These actions
            // are distinguished by their actionId, that is the ID of the prototype action.
            if (this.get("actionId")) {
                identifier.actionId = this.get("actionId");
            }

            return identifier;
        }


    }, {
        NOT_EMBEDDED_MESSAGE: "Please test the Action when your Experience is embedded on your website and/or via Drag'n Drop Publishing."
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/ActionEditorMixin.js